<div [class]="'mzic-alert__' + this.variant">
  <span>{{this.message}}</span>
</div>
